<script> </script>

export function pushToVwo(event, data, isLog = false) {
  if(isLog) {
    console.info('Pushed to VWO: ', event, data)
  }
  const VWO = window.VWO || []
  VWO.event = VWO.event || function() { VWO.push(['event'].concat([].slice.call(arguments))) }
  VWO.event(event, data)
}
